import React, { useEffect } from "react";
import "./App.css";
import { BookingProvider } from "./context/BookingContext";
import BookingForm from "./components/BookingForm";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import RedeemTicket from "./components/RedemptionPage";
import RedeemTicketLink from "./components/RedemptionPageLink";

const MenuRedirect = () => {
  React.useEffect(() => {
    window.location.href = process.env.REACT_APP_DRIVE_URL;
  }, []);

  return null; // Optionally, you can show a loading message
};

function App() {
  return (
    <Router>
      <Routes>
        <Route
          path="/"
          element={
            <div className="flex flex-row justify-center items-center w-full h-screen">
              <div className="flex flex-row justify-evenly items-center w-full flex-wrap">
                <a href="/booking" className="rounded p-2 bg-blue-400">
                  Football Booking
                </a>

                <a href="/menu" className="rounded p-2 bg-blue-400">
                  Adrenaline Menu
                </a>
              </div>
            </div>
          }
        />

        <Route
          path="/booking"
          element={
            <BookingProvider>
              <div className="flex flex-col items-center justify-center min-h-screen p-4 bg-gray-100 sm:p-6 lg:p-10">
                <h1 className="text-3xl font-bold text-blue-500 mb-8 text-center">
                  Ticket Booking
                </h1>
                <div className="w-full max-w-lg bg-white shadow-lg rounded-lg p-6 space-y-6">
                  <BookingForm />
                  {/* <BookingSummary /> */}
                </div>
              </div>
            </BookingProvider>
          }
        />

        <Route path="/redeem" element={<RedeemTicket />} />

        <Route path="/redeem/:ticketId" element={<RedeemTicketLink />} />

        <Route path="/menu" element={<MenuRedirect />} />
      </Routes>
    </Router>
  );
}

export default App;
